import(/* webpackMode: "eager" */ "/opt/build/repo/packages/implentio-app/packages/ui/src/app/global-error.tsx")